import { makeObservable, observable, action } from "mobx";

class OrderStore {
  orders = [];

  constructor() {
    makeObservable(this, {
      orders: observable,
      setOrders: action,
    });
  }

  setOrders = async (orders) => {
    this.orders = orders;
  };
}

const orderStore = new OrderStore();
export default orderStore;
